<template>
  <md-modal-dialog v-slot="{sap}" data-size="big">
    <md-dialog-title>
        <div class="sap-info">
            <div>SAP {{selectedRow.materialNumber}} - <span class="sapDesc">{{selectedRow.description}}</span></div>
            <md-button class="md-icon-button" @click="printDetail()">
            <md-icon>print</md-icon>
            </md-button>
        </div>
    </md-dialog-title>
    <md-dialog-content>
        <md-card class="md-layout-item md-size-100" class="sap-data">
            <md-card-content>
                <md-card>
                    <md-card-content>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.depot !== 0">
                                <div class="filterField">
                                    <strong>Magazino: </strong> {{depotDesc}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.elogate">
                                <div class="filterField">
                                    <strong>ELOGATE di Carico: </strong> {{currentFilters.elogate}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.pos">
                                <div class="filterField">
                                    <strong>POS di Carico: </strong> {{currentFilters.pos}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.numeroMagazzino">
                                <div class="filterField">
                                    <strong>Num. magazzino di Carico: </strong> {{currentFilters.numeroMagazzino}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.deliveryNote">
                                <div class="filterField">
                                    <strong>Delivery Note di Carico: </strong> {{currentFilters.deliveryNote}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.deliveryNoteScarico">
                                <div class="filterField">
                                    <strong>Delivery Note di Scarico: </strong> {{currentFilters.deliveryNoteScarico}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-20" v-show="currentFilters.dateFromFormatted || currentFilters.dateToFormatted">
                                <div class="filterField">
                                    <strong>Data di Carico da:</strong> {{printDateFilterValue(currentFilters.dateFromFormatted)}} <strong>a</strong> {{printDateFilterValue(currentFilters.dateToFormatted)}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-20" v-show="currentFilters.dateScaricoFromFormatted || currentFilters.dateScaricoToFormatted">
                                <div class="filterField">
                                    <strong>Data di Scarico da:</strong> {{printDateFilterValue(currentFilters.dateScaricoFromFormatted)}} <strong>a</strong> {{printDateFilterValue(currentFilters.dateScaricoToFormatted)}} 
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-20">
                                <div class="filterField">
                                    <strong>Escludi giacenze a 0: </strong> <span v-show="currentFilters.giacenza">Si</span> <span v-show="!currentFilters.giacenza">No</span> 
                                </div>
                            </div>
                        </div>
                    </md-card-content>
                </md-card>
            
                <md-table class="fullScreen">
                    <md-table-row>
                      <md-table-head class="type">&nbsp;</md-table-head>
                      <md-table-head class="w85">Data</md-table-head>
                      <md-table-head class="w120">Delivery Note</md-table-head>
                      <md-table-head>Elogate</md-table-head>
                      <md-table-head>Transport Mean</md-table-head>
                      <md-table-head class="w120">Pos</md-table-head>
                      <md-table-head class="w120">Numero Magazzino</md-table-head>
                      <md-table-head>Caricato</md-table-head>
                      <md-table-head>Scaricato</md-table-head>
                      <md-table-head>Rimanenza</md-table-head>
                    </md-table-row>
                    <template v-for="row in sap.data.ingressi">
                        <md-table-row>
                            <md-table-cell class="type"><md-icon>login</md-icon></md-table-cell>
                            <md-table-cell class="w85">{{row.orderDate}}</md-table-cell>
                            <md-table-cell class="w120">{{row.deliveryNote}}</md-table-cell>
                            <md-table-cell>{{row.elogate}}</md-table-cell>
                            <md-table-cell>{{row.transportMean}}</md-table-cell>
                            <md-table-cell class="w120">{{row.pos}}</md-table-cell>
                            <md-table-cell class="w120">{{row.numeroMagazzino}}</md-table-cell>
                            <md-table-cell>{{row.caricato | formatAmount}}</md-table-cell>
                            <md-table-cell>{{row.scaricato | formatAmount}}</md-table-cell>
                            <md-table-cell>{{row.rimanenza | formatAmount}}</md-table-cell>
                        </md-table-row>
                        <md-table-row v-show="row.uscite.length > 0">
                            <md-table-cell class="type"><span class="linked">&nbsp;</span></md-table-cell>
                            <td colspan="9">
                                <md-table class="fullScreen boxed">
                                    <md-table-row>
                                      <md-table-head class="w85">Data</md-table-head>
                                      <md-table-head class="w120">Delivery Note</md-table-head>
                                      <md-table-head>Ordine di carico</md-table-head>
                                      <md-table-head>Elogate</md-table-head>
                                      <md-table-head>Transport Mean</md-table-head>
                                      <md-table-head class="w120">Pos</md-table-head>
                                      <md-table-head class="w120">CMR</md-table-head>
                                      <md-table-head class="w120">Scaricato</md-table-head>
                                    </md-table-row>
                                    <template v-for="uscita in row.uscite">
                                        <md-table-row>
                                            <md-table-cell class="w85">{{uscita.date}}</md-table-cell>
                                            <md-table-cell class="w120">{{uscita.deliveryNote}}</md-table-cell>
                                            <md-table-cell>{{uscita.ordineDiCarico}}</md-table-cell>
                                            <md-table-cell>{{uscita.elogate}}</md-table-cell>
                                            <md-table-cell>{{uscita.transportMean}}</md-table-cell>
                                            <md-table-cell class="w120">{{uscita.pos}}</md-table-cell>
                                            <md-table-cell class="w120">{{uscita.cmr}}</md-table-cell>
                                            <md-table-cell class="w120">{{uscita.pallet | formatAmount}}</md-table-cell>
                                        </md-table-row>
                                    </template>
                                </md-table>
                            </td>
                        </md-table-row>
                    </template>
                    <md-table-row>
                    <md-table-cell class="type">&nbsp;</md-table-cell>
                    <md-table-cell colspan="6">&nbsp;</md-table-cell>
                    <md-table-cell><strong>Tot Caricato:</strong> {{sap.data.totali.caricato| formatAmount}}</md-table-cell>
                    <md-table-cell><strong>Tot Scaricato:</strong> {{sap.data.totali.scaricato | formatAmount}}</md-table-cell>
                    <md-table-cell><strong>Rimanenza:</strong> {{sap.data.totali.rimanenza | formatAmount}}</md-table-cell>
                  </md-table-row>

                </md-table>
                <div style="height:1px;overflow:hidden;" class="sap-data-printable">
                    <h3 style="width:100%; white-space:nowrap;">SAP {{selectedRow.materialNumber}} - <span class="sapDesc">{{selectedRow.description}}</span></h3>
                    <p>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.depot !== 0">
                                <div class="filterField">
                                    <strong>Magazino: </strong> {{depotDesc}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.elogate">
                                <div class="filterField">
                                    <strong>ELOGATE di Carico: </strong> {{currentFilters.elogate}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.pos">
                                <div class="filterField">
                                    <strong>POS di Carico: </strong> {{currentFilters.pos}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.numeroMagazzino">
                                <div class="filterField">
                                    <strong>Num. magazzino di Carico: </strong> {{currentFilters.numeroMagazzino}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.deliveryNote">
                                <div class="filterField">
                                    <strong>Delivery Note di Carico: </strong> {{currentFilters.deliveryNote}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-80 md-size-20" v-show="currentFilters.deliveryNoteScarico">
                                <div class="filterField">
                                    <strong>Delivery Note di Scarico: </strong> {{currentFilters.deliveryNoteScarico}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-20" v-show="currentFilters.dateFromFormatted || currentFilters.dateToFormatted">
                                <div class="filterField">
                                    <strong>Data di Carico da:</strong> {{printDateFilterValue(currentFilters.dateFromFormatted)}} <strong>a</strong> {{printDateFilterValue(currentFilters.dateToFormatted)}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-20" v-show="currentFilters.dateScaricoFromFormatted || currentFilters.dateScaricoToFormatted">
                                <div class="filterField">
                                    <strong>Data di Scarico da:</strong> {{printDateFilterValue(currentFilters.dateScaricoFromFormatted)}} <strong>a</strong> {{printDateFilterValue(currentFilters.dateScaricoToFormatted)}}
                                </div>
                            </div>
                            <div class="md-layout-item md-small-size-100 md-size-20">
                                <div class="filterField">
                                    <strong>Escludi giacenze a 0: </strong> <span v-show="currentFilters.giacenza">Si</span> <span v-show="!currentFilters.giacenza">No</span> 
                                </div>
                            </div>
                        </div>
                    </p>
                    <md-table class="fullScreen" style="width:100%;">
                        <md-table-row>
                            <md-table-head>Data</md-table-head>
                            <md-table-head>Delivery Note</md-table-head>
                            <md-table-head>Elogate</md-table-head>
                            <md-table-head>Transport Mean</md-table-head>
                            <md-table-head>Pos</md-table-head>
                            <md-table-head>Numero Magazzino</md-table-head>
                            <md-table-head>Caricato</md-table-head>
                            <md-table-head>Scaricato</md-table-head>
                            <md-table-head>Rimanenza</md-table-head>
                        </md-table-row>
                        <template v-for="row in sap.data.ingressi">
                        <md-table-row>
                            <md-table-cell>{{row.orderDate}}</md-table-cell>
                            <md-table-cell>{{row.deliveryNote}}</md-table-cell>
                            <md-table-cell>{{row.elogate}}</md-table-cell>
                            <md-table-cell>{{row.transportMean}}</md-table-cell>
                            <md-table-cell>{{row.pos}}</md-table-cell>
                            <md-table-cell>{{row.numeroMagazzino}}</md-table-cell>
                            <md-table-cell>{{row.caricato | formatAmount}}</md-table-cell>
                            <md-table-cell>{{row.scaricato | formatAmount}}</md-table-cell>
                            <md-table-cell>{{row.rimanenza | formatAmount}}</md-table-cell>
                        </md-table-row>
                        <md-table-row v-show="row.uscite.length > 0">
                            <td colspan="9">
                                <table class="fullScreen boxed">
                                    <md-table-row>
                                      <md-table-head>Data</md-table-head>
                                      <md-table-head>Delivery Note</md-table-head>
                                      <md-table-head>Ordine di carico</md-table-head>
                                      <md-table-head>Elogate</md-table-head>
                                      <md-table-head>Transport Mean</md-table-head>
                                      <md-table-head>Pos</md-table-head>
                                      <md-table-head>CMR</md-table-head>
                                      <md-table-head>Scaricato</md-table-head>
                                    </md-table-row>
                                    <template v-for="uscita in row.uscite">
                                        <md-table-row>
                                            <md-table-cell>{{uscita.date}}</md-table-cell>
                                            <md-table-cell>{{uscita.deliveryNote}}</md-table-cell>
                                            <md-table-cell>{{uscita.ordineDiCarico}}</md-table-cell>
                                            <md-table-cell>{{uscita.elogate}}</md-table-cell>
                                            <md-table-cell>{{uscita.transportMean}}</md-table-cell>
                                            <md-table-cell>{{uscita.pos}}</md-table-cell>
                                            <md-table-cell>{{uscita.cmr}}</md-table-cell>
                                            <md-table-cell>{{uscita.pallet | formatAmount}}</md-table-cell>
                                        </md-table-row>
                                    </template>
                                </md-table>
                            </td>
                        </md-table-row>
                        </template>
                        <md-table-row>
                            <md-table-cell class="type">&nbsp;</md-table-cell>
                            <md-table-cell colspan="6">&nbsp;</md-table-cell>
                            <md-table-cell><strong>Tot Caricato:</strong> {{sap.data.totali.caricato| formatAmount}}</md-table-cell>
                            <md-table-cell><strong>Tot Scaricato:</strong> {{sap.data.totali.scaricato | formatAmount}}</md-table-cell>
                            <md-table-cell><strong>Rimanenza:</strong> {{sap.data.totali.rimanenza | formatAmount}}</md-table-cell>
                          </md-table-row>
                    </md-table>
                </div>
            </md-card-content>
        </md-card>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary" @click="onClose()"">Chiudi</md-button>
    </md-dialog-actions>
  </md-modal-dialog>
</template>
<script>

  import print from 'print-js'
  import moment from 'moment'
  
  export default {
    name: 'SAPDetail',
    data: () => ({
        sap: {
            materialNumber : '', 
            description : '', 
          data: {
              'ingressi' : [],
              'uscite' : [],
          }
        }
    }),
    props: ['depotDesc', 'selectedRow', 'currentFilters'],
    methods: {
      onClose() {
          this.$modal.cancel()
      },
      printDateFilterValue(value) {
          if (value.length === 0) 
              return 'qualsiasi'
          return moment(value).format('DD/MM/YYYY')
      },
      printDetail() {
          
          document.getElementById('print-container').innerHTML = document.querySelector('.sap-data-printable').innerHTML
          printJS({ css:'/css/print.css', printable: 'print-container', type: 'html', documentTitle: 'Goriziana Srl', header: '' , targetStyle : ['border','padding','padding-right','padding-left','display','border-top-color','border-top-style','border-top-width','border-right-color','border-right-style','border-right-width','border-bottom-color','border-bottom-style','border-bottom-width','border-left-color','border-left-style','border-left-width','border-image-outset','border-image-repeat','border-image-slice','border-image-source','border-image-width']})
          
          
      }
//        this.$emit('close-sap-detail')
//      }
    }
  }

</script>

<style lang="css" scoped>
    .sapDesc {
        width:100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 100;
    }
    .type {
        width: 50px;
        max-width: 50px;
    }
    .linked {
        display: inline-block;
        border-left: 2px solid #666;
        border-bottom: 2px solid #666;
        width: 20px;
        margin-left: 16px;
        height: 12px;
    }
    .boxed {
        border: 2px solid #666;
        margin: 10px 0;
    }
    .sap-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    @media print {
        .type {display:none; width:1px;max-width:1px;}
        .type .md-table-cell-container, .type .md-table-cell-container .md-icon {display:none;}
        .md-table-head-label {padding-left:0px;}
    }
</style>



// WEBPACK FOOTER //
// src/components/SAPDetail.vue